import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivityComponent } from './activity.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ViewAllItemComponent } from './view-all-item/view-all-item.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { SharedLayoutModule } from '../../shared-layout.module';
import { AccessPointFilterActvityModule } from './access-point-filter-actvity/access-point-filter-actvity.module';
import { ParsedDateTimeModule } from 'src/app/libs/ui/pipes/parsed-date-time/parsed-date-time.module';
import { ParsedActivityDateTimeModule } from 'src/app/libs/ui/pipes/parsed-activity-date-time/parsed-activity-date-time.pipe.module';
import { MediatorModule } from 'src/app/libs/ui/pipes/mediator/mediator.pipe.module';
import { UniqueChangeDetectorCharacterModule } from 'src/app/libs/ui/pipes/unique-change-detector-character/unique-change-detector-character.pipe.module';
import { EventImageModule } from 'src/app/libs/ui/pipes/event-image-pipe/event-image.module';
import { WithTooltipModule } from '../with-tooltip/with-tooltip.module';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@NgModule({
  declarations: [ActivityComponent, ViewAllItemComponent],
  imports: [
    CommonModule,
    MatFormFieldModule,
    InfiniteScrollModule,
    SharedLayoutModule,
    WithTooltipModule,
    AccessPointFilterActvityModule,
    ParsedDateTimeModule,
    ParsedActivityDateTimeModule,
    UniqueChangeDetectorCharacterModule,
    MediatorModule,
    EventImageModule,
    TranslateModule
  ],
  exports: [ActivityComponent],
  providers: [
    LocalizationService,
    TranslateModule
  ],
})
export class ActivityModule {}
